import IconFA from "../../components/icon/icon";

function OfferCard({ index, offerCardTitle, offerCardDescription }) {
    const bgColors = ['#448C7419', '#EDCB5019', '#3F7FCA19', '#ED505019', '#6A4D8C19', '#73B54C19', '#F2994A19', '#C94C6C19'];
    const iconList = ['gear', 'envelopesBulk', 'lightbulb', 'locationArrow', 'doorOpen', 'addressBook', 'person', 'fileLines'];
    const icon = iconList[index]
    const backgroundColor = bgColors[index];

    const style = {
        maxWidth: '300px',
        borderRadius: '40px',
        padding: '20px',
        backgroundColor,
    };

    return (
        <div style={style}>
            <IconFA iconName={icon} />
            <h3>{offerCardTitle}</h3>
            <p>
                {offerCardDescription}
            </p>
        </div>
    );
}

export default OfferCard;